/* istanbul ignore file */
import { Tooltip, Button } from 'framework/ui/mui-builder';
import { copyToClipboard } from 'framework/ui/clipboard';
import { Typography } from '@mui/material';

type OneStopErrorMessageProps = {
  message: string;
  processId: string;
};

const OneStopErrorMessage = ({ message, processId }: OneStopErrorMessageProps) => {
  const containerClassName = 'one-stop-error__wrapper';
  const getSupportLink = () =>
    `${process.env.REACT_APP_DAVINCI_FRONTEND_REDMINE_SUPPORT_URL}`.replace(/{%processId%}/i, processId);

  return (
    <div className={containerClassName}>
      <Typography variant="body1">{message}</Typography>
      <Typography variant="body1">
        Please create a ticket in Project Process Support following&nbsp;
        <a href={getSupportLink()} target="_blank" rel="noopener noreferrer">
          this link
        </a>
      </Typography>
      <Typography component="p" variant="body1">
        or contact your supervising manager
      </Typography>
      <Typography variant="body1">
        your reference request ID is&nbsp;
        <Button
          link
          onClick={() => {
            copyToClipboard(processId, `.${containerClassName}`);
          }}
          id="copy-main"
          className="copy-anchor p-0 one-stop-error__copy-anchor"
        >
          <Tooltip title="Copy Request ID" placement="right" id="copy-main">
            <span>{`#${processId}`}</span>
          </Tooltip>
        </Button>
      </Typography>
    </div>
  );
};

export default OneStopErrorMessage;
